import { render } from "./impact_exchange_rate_section.html?vue&type=template&id=275fc018&external"
import script from "./impact_exchange_rate_section.js?vue&type=script&lang=js&external"
export * from "./impact_exchange_rate_section.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__